<template>
  <h3 class='title' v-if="getProductDetail.product">{{ getProductDetail.product.product_name }}</h3>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
  name: 'ProductHeader',
  computed: {
    ...mapGetters([
      'getProductDetail'
    ])
  }
}
</script>

<style type='text/css' lang='scss' scoped>
  .title {
    color: #000000;
    margin-top: 10px;
    font-weight: bold;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productDetail/productHeader.vue